import React from 'react';
import Header from './Header';

const Layout = ({ children }) => (
  <>
    <Header />
    <main id="main-content" role="main">
      {children}
    </main>
  </>
);

export default Layout;
